import React from 'react';
import { useAtomValue } from 'jotai';
import type { SearchSuggestion } from '@rocco/ui/search/view-models/search-suggestion';
import type { useCategoryFilterSort } from '@ui-rocco/hooks/use-category-filter-sort';
import { useRecentlyViewed } from '~/modules-rocco/recently-viewed/hooks/use-recently-viewed';
import { SearchSuggestedCategories } from './SearchSuggestedCategories';
import { SearchResultPageTilesGrid } from './SearchResultPageTilesGrid';
import { SearchPageRecentlyViewed } from './SearchPageRecentlyViewed';
import { searchPageDataAtom } from '../states/search-page-data-atom';

interface SearchPageContentSectionsDesktopProps {
    filterSortProps: ReturnType<typeof useCategoryFilterSort>;
    onSuggestedCategoryClick: (category: SearchSuggestion) => void;
    isLoading: boolean;
}

/**
 * Renders the content sections for the desktop view of the search page.
 * Includes suggested categories, search results grid, and recently viewed items.
 */
export const SearchPageContentSectionsDesktop: React.FC<
    SearchPageContentSectionsDesktopProps
> = ({ filterSortProps, onSuggestedCategoryClick, isLoading }) => {
    const pageDataFromAtom = useAtomValue(searchPageDataAtom);
    const suggestedCategories = pageDataFromAtom?.suggestedCategories ?? [];
    const { recentlyViewed } = useRecentlyViewed();

    return (
        <div className="space-y-35">
            {suggestedCategories.length > 0 ? (
                <SearchSuggestedCategories
                    onSuggestedCategoryClick={onSuggestedCategoryClick}
                />
            ) : null}
            <section>
                <SearchResultPageTilesGrid
                    {...filterSortProps}
                    isLoading={isLoading}
                />
            </section>
            {pageDataFromAtom && recentlyViewed.length > 0 ? (
                <section className="pb-28">
                    <SearchPageRecentlyViewed recentlyViewed={recentlyViewed} />
                </section>
            ) : null}
        </div>
    );
};
